function getTenantFromSubdomain() {
  const hostParts = window.location.host.split(".");
  if (hostParts.length < 3) {
    throw new Error("Failed to set tenant: no subdomain.");
  }
  return hostParts[0];
}
export default function getTenant(): string {
  if (process.env.REACT_APP_DIALER_TENANT_FROM_SUBDOMAIN) {
    return getTenantFromSubdomain();
  } else if (process.env.REACT_APP_DIALER_TENANT) {
    return process.env.REACT_APP_DIALER_TENANT;
  } else {
    throw new Error("Misconfigured: missing tenant configuration");
  }
}
